import React from "react";

// SVG mockups of secure documents — designed to feel institutional without
// exposing real specimens. Marked "SPECIMEN" for integrity, per brief.

export const PassportMockup = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <defs>
      <linearGradient id="passCover" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#0b3d2f" />
        <stop offset="1" stopColor="#062018" />
      </linearGradient>
      <pattern id="passWave" width="18" height="18" patternUnits="userSpaceOnUse">
        <path d="M0 9 Q4.5 0 9 9 T18 9" fill="none" stroke="rgba(255,215,150,0.09)" strokeWidth="0.7" />
      </pattern>
    </defs>
    <rect x="10" y="20" width="380" height="230" rx="6" fill="url(#passCover)" />
    <rect x="10" y="20" width="380" height="230" rx="6" fill="url(#passWave)" />
    <rect x="10" y="20" width="380" height="230" rx="6" fill="none" stroke="rgba(255,215,150,0.2)" />
    <text x="200" y="70" textAnchor="middle" fill="#d9c48a" fontSize="12" letterSpacing="4" fontFamily="Outfit, sans-serif">
      RÉPUBLIQUE — SPÉCIMEN
    </text>
    <text x="200" y="110" textAnchor="middle" fill="#e9d9a4" fontSize="26" letterSpacing="8" fontFamily="Outfit, sans-serif" fontWeight="600">
      PASSEPORT
    </text>
    <g transform="translate(200,155)">
      <circle r="26" fill="none" stroke="#d9c48a" strokeWidth="1" />
      <circle r="18" fill="none" stroke="#d9c48a" strokeWidth="0.6" />
      <path d="M-14,0 A14,14 0 0 1 14,0" stroke="#d9c48a" strokeWidth="0.6" fill="none" />
      <path d="M-14,0 A14,14 0 0 0 14,0" stroke="#d9c48a" strokeWidth="0.6" fill="none" />
      <line x1="-24" y1="0" x2="24" y2="0" stroke="#d9c48a" strokeWidth="0.6" />
      <line x1="0" y1="-26" x2="0" y2="26" stroke="#d9c48a" strokeWidth="0.6" />
    </g>
    <g transform="translate(200,215)">
      <rect x="-16" y="-8" width="32" height="16" fill="none" stroke="#d9c48a" strokeWidth="0.8" />
      <circle cx="0" cy="0" r="4" fill="none" stroke="#d9c48a" strokeWidth="0.8" />
      <line x1="4" y1="0" x2="14" y2="0" stroke="#d9c48a" strokeWidth="0.8" />
      <line x1="-4" y1="0" x2="-14" y2="0" stroke="#d9c48a" strokeWidth="0.8" />
    </g>
  </svg>
);

export const IDCardMockup = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <defs>
      <linearGradient id="idBg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#0f2b3a" />
        <stop offset="1" stopColor="#08161f" />
      </linearGradient>
    </defs>
    <rect x="20" y="40" width="360" height="200" rx="12" fill="url(#idBg)" stroke="rgba(0,137,200,0.5)" />
    <rect x="20" y="40" width="360" height="26" rx="12" fill="#0089C8" />
    <text x="35" y="58" fill="#fff" fontSize="10" letterSpacing="3" fontFamily="Outfit, sans-serif">
      {"CARTE NATIONALE D'IDENTITÉ — SPECIMEN"}
    </text>

    {/* Photo */}
    <rect x="40" y="90" width="90" height="115" fill="#1b2b39" stroke="rgba(255,255,255,0.15)" />
    <circle cx="85" cy="130" r="20" fill="#243546" />
    <path d="M55 205 Q85 165 115 205 Z" fill="#243546" />

    {/* Fields */}
    <g fontFamily="Outfit, sans-serif" fill="#cbd5e1">
      <text x="150" y="100" fontSize="8" letterSpacing="2" fill="#64748b">SURNAME</text>
      <text x="150" y="114" fontSize="12">SPECIMEN</text>
      <text x="150" y="135" fontSize="8" letterSpacing="2" fill="#64748b">GIVEN NAMES</text>
      <text x="150" y="149" fontSize="12">SPECIMEN</text>
      <text x="150" y="170" fontSize="8" letterSpacing="2" fill="#64748b">DATE OF BIRTH</text>
      <text x="150" y="184" fontSize="12">01 · 01 · 1980</text>
      <text x="150" y="205" fontSize="8" letterSpacing="2" fill="#64748b">DOCUMENT NO</text>
      <text x="150" y="219" fontSize="12">CN 0000000</text>
    </g>

    {/* Chip */}
    <g transform="translate(320,150)">
      <rect x="-14" y="-10" width="28" height="20" rx="2" fill="#c9a24c" />
      <g stroke="#8b6f2a" strokeWidth="0.6">
        <line x1="-14" y1="-4" x2="14" y2="-4" />
        <line x1="-14" y1="4" x2="14" y2="4" />
        <line x1="-6" y1="-10" x2="-6" y2="10" />
        <line x1="6" y1="-10" x2="6" y2="10" />
      </g>
    </g>

    <text x="35" y="232" fill="#0089C8" fontSize="8" letterSpacing="4" fontFamily="Outfit, sans-serif">
      &lt;&lt;SPECIMEN&lt;&lt;SPECIMEN&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;&lt;
    </text>
  </svg>
);

export const VisaMockup = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <defs>
      <linearGradient id="visaBg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#2a1810" />
        <stop offset="1" stopColor="#160a05" />
      </linearGradient>
      <pattern id="visaGuilloche" width="16" height="16" patternUnits="userSpaceOnUse">
        <circle cx="8" cy="8" r="7" fill="none" stroke="rgba(255,107,53,0.12)" strokeWidth="0.5" />
      </pattern>
    </defs>
    <rect x="30" y="20" width="340" height="220" rx="4" fill="url(#visaBg)" stroke="rgba(255,107,53,0.4)" />
    <rect x="30" y="20" width="340" height="220" rx="4" fill="url(#visaGuilloche)" />
    <text x="200" y="60" textAnchor="middle" fill="#f8d1b2" fontSize="12" letterSpacing="6" fontFamily="Outfit, sans-serif">
      VISA — SPECIMEN
    </text>
    <text x="200" y="98" textAnchor="middle" fill="#FF6B35" fontSize="22" letterSpacing="6" fontFamily="Outfit, sans-serif" fontWeight="600">
      ENTRY VISA
    </text>

    <g transform="translate(60,120)" fontFamily="Outfit, sans-serif" fill="#f8d1b2">
      <text fontSize="8" letterSpacing="2" fill="#a48a76">CATEGORY</text>
      <text y="14" fontSize="12">DIPLOMATIC / SERVICE</text>
      <text y="42" fontSize="8" letterSpacing="2" fill="#a48a76">VALID FROM</text>
      <text y="56" fontSize="12">01 · 01 · 2026</text>
      <text y="82" fontSize="8" letterSpacing="2" fill="#a48a76">CONTROL NO</text>
      <text y="96" fontSize="12">VS-000-000</text>
    </g>

    <g transform="translate(300,180)">
      <circle r="30" fill="none" stroke="#FF6B35" strokeWidth="0.8" opacity="0.5" />
      <circle r="22" fill="none" stroke="#FF6B35" strokeWidth="0.8" opacity="0.7" />
      <text textAnchor="middle" y="-6" fill="#FF6B35" fontSize="7" letterSpacing="1.5" fontFamily="Outfit, sans-serif">
        REPUBLIC
      </text>
      <text textAnchor="middle" y="6" fill="#FF6B35" fontSize="10" fontFamily="Outfit, sans-serif" fontWeight="600">
        SEAL
      </text>
    </g>
  </svg>
);

export const StampMockup = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <defs>
      <linearGradient id="stBg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#04321f" />
        <stop offset="1" stopColor="#012014" />
      </linearGradient>
      <pattern id="stampPerf" width="18" height="18" patternUnits="userSpaceOnUse">
        <circle cx="9" cy="9" r="4" fill="#0f1826" />
      </pattern>
    </defs>
    <rect x="60" y="30" width="280" height="200" fill="url(#stampPerf)" />
    <rect x="70" y="40" width="260" height="180" fill="url(#stBg)" stroke="rgba(0,137,200,0.5)" />

    <text x="200" y="72" textAnchor="middle" fill="#8ce4be" fontSize="10" letterSpacing="4" fontFamily="Outfit, sans-serif">
      TIMBRE FISCAL — SPECIMEN
    </text>
    <g transform="translate(200,140)">
      <circle r="42" fill="none" stroke="#0089C8" strokeWidth="0.8" />
      <circle r="30" fill="none" stroke="#0089C8" strokeWidth="0.6" />
      <text textAnchor="middle" y="-8" fill="#8ce4be" fontSize="7" letterSpacing="2" fontFamily="Outfit, sans-serif">
        RÉPUBLIQUE
      </text>
      <text textAnchor="middle" y="6" fill="#fff" fontSize="14" fontFamily="Outfit, sans-serif" fontWeight="600">
        1 000
      </text>
      <text textAnchor="middle" y="20" fill="#8ce4be" fontSize="7" letterSpacing="2" fontFamily="Outfit, sans-serif">
        FRANCS
      </text>
    </g>
    <text x="200" y="210" textAnchor="middle" fill="#0089C8" fontSize="7" letterSpacing="3" fontFamily="Outfit, sans-serif">
      SN · 0000 0000 0000
    </text>
  </svg>
);

export const LicenceMockup = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <defs>
      <linearGradient id="dlBg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#101820" />
        <stop offset="1" stopColor="#050a10" />
      </linearGradient>
    </defs>
    <rect x="20" y="40" width="360" height="200" rx="12" fill="url(#dlBg)" stroke="rgba(0,137,200,0.4)" />
    <rect x="20" y="40" width="360" height="24" fill="#044D29" />
    <text x="35" y="57" fill="#8ce4be" fontSize="10" letterSpacing="3" fontFamily="Outfit, sans-serif">
      DRIVING LICENCE — SPECIMEN
    </text>
    <rect x="40" y="90" width="80" height="100" fill="#1b2b39" stroke="rgba(255,255,255,0.15)" />
    <circle cx="80" cy="125" r="18" fill="#243546" />
    <path d="M52 190 Q80 155 108 190 Z" fill="#243546" />
    <g fontFamily="Outfit, sans-serif" fill="#cbd5e1">
      <text x="140" y="100" fontSize="8" letterSpacing="2" fill="#64748b">NAME</text>
      <text x="140" y="114" fontSize="12">SPECIMEN</text>
      <text x="140" y="135" fontSize="8" letterSpacing="2" fill="#64748b">CLASSES</text>
      <text x="140" y="149" fontSize="14" fill="#8ce4be" letterSpacing="4">A · B · C · D</text>
      <text x="140" y="170" fontSize="8" letterSpacing="2" fill="#64748b">LICENCE NO</text>
      <text x="140" y="184" fontSize="12">DL 000 000</text>
    </g>
    <g transform="translate(320,150)">
      <rect x="-14" y="-10" width="28" height="20" rx="2" fill="#c9a24c" />
      <g stroke="#8b6f2a" strokeWidth="0.6">
        <line x1="-14" y1="-4" x2="14" y2="-4" />
        <line x1="-14" y1="4" x2="14" y2="4" />
        <line x1="-6" y1="-10" x2="-6" y2="10" />
        <line x1="6" y1="-10" x2="6" y2="10" />
      </g>
    </g>
    <text x="35" y="228" fill="#8ce4be" fontSize="7" letterSpacing="3" fontFamily="Outfit, sans-serif">
      &lt;&lt;SPECIMEN&lt;&lt;SPECIMEN&lt;&lt;
    </text>
  </svg>
);

export const CivilMockup = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <defs>
      <pattern id="paperGuilloche" width="20" height="20" patternUnits="userSpaceOnUse">
        <path d="M0,10 Q5,0 10,10 T20,10" fill="none" stroke="rgba(0,137,200,0.15)" strokeWidth="0.5" />
        <path d="M0,15 Q5,5 10,15 T20,15" fill="none" stroke="rgba(0,137,200,0.10)" strokeWidth="0.5" />
      </pattern>
    </defs>
    <rect x="40" y="20" width="320" height="220" fill="#0e141a" stroke="rgba(0,137,200,0.4)" />
    <rect x="40" y="20" width="320" height="220" fill="url(#paperGuilloche)" />
    <text x="200" y="60" textAnchor="middle" fill="#0089C8" fontSize="10" letterSpacing="4" fontFamily="Outfit, sans-serif">
      DOCUMENT FIDUCIAIRE — SPECIMEN
    </text>
    <text x="200" y="100" textAnchor="middle" fill="#fff" fontSize="20" letterSpacing="4" fontFamily="Outfit, sans-serif" fontWeight="500">
      {"ACTE D'ÉTAT CIVIL"}
    </text>
    <g stroke="rgba(255,255,255,0.15)">
      <line x1="70" y1="130" x2="330" y2="130" />
      <line x1="70" y1="150" x2="330" y2="150" />
      <line x1="70" y1="170" x2="330" y2="170" />
      <line x1="70" y1="190" x2="260" y2="190" />
    </g>
    <g transform="translate(320,205)">
      <circle r="18" fill="none" stroke="#FF6B35" strokeWidth="0.8" />
      <text textAnchor="middle" y="4" fill="#FF6B35" fontSize="8" letterSpacing="2" fontFamily="Outfit, sans-serif">
        SEAL
      </text>
    </g>
  </svg>
);
